export default function getPathFromParams(pathArray, routeParams, userParams) {
  const resultArray = pathArray.map((segment) => {
    switch (segment.type) {
      case 'collection':
        return segment.value;
      case 'param':
        return routeParams[segment.value];
      case 'user':
        return routeParams?.[segment.value] || userParams?.[segment.value];
      default:
        return null;
    }
  });

  const result = resultArray.join('/');
  return result;
}

export function getCollectionPath(pathArray, routeParams, userParams) {
  if (pathArray.length % 2 > 0) {
    // Paths with an odd number od segments are collection paths
    return getPathFromParams(pathArray, routeParams, userParams);
  } else {
    // Paths with an even number of segments point to individual documents and need to be truncated
    const collectionPathArray = pathArray.slice(0, -1);
    return getPathFromParams(collectionPathArray, routeParams, userParams);
  }
}
